import { createGlobalStyle } from 'styled-components'

export const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: 'Lexend Deca';
    src: url('/fonts/LexendDeca-Variable.ttf') format("truetype-variations");
    font-weight: 100 900;
    font-display: fallback;
  }

  @font-face {
    font-family: 'Assistant';
    src: url('/fonts/Assistant-Variable.ttf') format("truetype-variations");
    font-weight: 100 900;
    font-display: fallback;
  }

  @font-face {
    font-family: 'Kapakana';
    src: url('/fonts/Kapakana-Variable.ttf') format("truetype-variations");
    font-weight: 100 900;
    font-display: fallback;
  }

  @font-face {
    font-family: 'Gilroy';
    src: url('/fonts/Gilroy-Variable.otf') format("opentype-variations");
    font-weight: 100 900;
    font-display: fallback;
  }

  html,  body,
  #__next {
    width: 100%;
    min-height: 100%;
  }

  body {
    overflow-x: hidden;
  }

  #__next {
    display: flex;
    flex-direction: column;
  }

  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    font-family: 'Lexend Deca', 'Sans';
  }
`
